module.exports = __webpack_public_path__ + "img/old-in-love-min.77dcc823.jpg";